"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const react_helmet_1 = __importDefault(require("react-helmet"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const UserInfoAvatar_1 = require("@Components/UserInfoAvatar");
const PointPreloader_1 = __importDefault(require("@Components/Preloaders/PointPreloader"));
const contexts_1 = require("@App/contexts");
const rightsholderUser_1 = require("@App/api/routes/rightsholder/rightsholderUser");
const react_router_dom_1 = require("react-router-dom");
const UserPermissionsModal_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/UserPermissionsModal"));
const PermissionHeadMenu_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/PermissionHeadMenu"));
const AssignedPermissionGroups_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderMaintenanceUserPermissionsProfile/AssignedPermissionGroups"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const RightsholderMaintenanceUserPermissionsProfile = () => {
    const params = (0, react_router_dom_1.useParams)();
    if (!params.userId) {
        throw new Error('no user id');
    }
    const { userStore, rightsholderUserStore, popupStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [rightsholderUser, setRightsholderUser] = (0, react_1.useState)();
    const [actionType, setActionType] = (0, react_1.useState)();
    const [myUserGroups, setMyUserGroups] = (0, react_1.useState)([]);
    const [editActionsGroups, setEditActionsGroups] = (0, react_1.useState)([]);
    const [editIsDisabled, setEditIsDisabled] = (0, react_1.useState)(true);
    const [confirmPopupIsOpen, setConfirmPopupIsOpen] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [userId, setUserId] = (0, react_1.useState)(params.userId);
    const setUsersGroup = (user) => {
        const userGroupsCollection = userStore.permissionGroups;
        const currentUserGroups = user && (user === null || user === void 0 ? void 0 : user.groups);
        if (currentUserGroups === null || currentUserGroups === void 0 ? void 0 : currentUserGroups.length) {
            const myUserGroupsMapped = userGroupsCollection.map((collectionItem) => {
                const result = currentUserGroups.find((userItem) => userItem.name === collectionItem.name);
                return Object.assign(Object.assign({}, collectionItem), { checked: !!result });
            });
            setMyUserGroups(myUserGroupsMapped);
        }
        else {
            const myUserGroupsMapped = userGroupsCollection.map((collectionItem) => (Object.assign(Object.assign({}, collectionItem), { checked: false, disabled: false })));
            setMyUserGroups(myUserGroupsMapped);
        }
    };
    const onCancelEdit = (user) => {
        setUsersGroup(user);
        setEditActionsGroups([]);
        setEditIsDisabled(true);
    };
    const onOpenConfirmPopup = (newActionType) => {
        setActionType(newActionType);
        setConfirmPopupIsOpen(true);
    };
    const onCloseConfirmPopup = () => {
        setConfirmPopupIsOpen(false);
    };
    const getUsersForUser = (user) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const group = (_a = user === null || user === void 0 ? void 0 : user.groups) === null || _a === void 0 ? void 0 : _a.map((item) => item.name).join();
        if (group) {
            setLoading(true);
            try {
                yield rightsholderUserStore.loadRightsholderUsersForUser(userId, {
                    limit: 5,
                    group: group,
                });
            }
            catch (error) {
                popupStore.setAlertFromError(error);
            }
            setLoading(false);
        }
    });
    const getUser = () => __awaiter(void 0, void 0, void 0, function* () {
        const currentRightsholderId = rightsholderStore.currentRightsholderId;
        try {
            const user = yield (0, rightsholderUser_1.getRightsholderUser)(currentRightsholderId, userId);
            setRightsholderUser(user.data);
            setUsersGroup(user.data);
            yield getUsersForUser(user.data);
        }
        catch (error) {
            popupStore.setAlertFromError(error);
        }
    });
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('rightsholder_maintenance_user_permissions_profile');
        return () => {
            rightsholderUserStore.destroyRightsHolderUser();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const userIdFromParams = params.userId;
        if (userId !== userIdFromParams) {
            if (!userIdFromParams) {
                throw new Error('no user id');
            }
            setUserId(userIdFromParams);
        }
    }, [params.userId]);
    (0, react_1.useEffect)(() => {
        onCancelEdit(rightsholderUser);
        rightsholderUserStore.destroyRightsHolderUser();
        getUser().then();
    }, [userId]);
    if (!rightsholderUser) {
        return react_1.default.createElement(PointPreloader_1.default, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'User Permissions Profile' }),
        react_1.default.createElement("div", { className: "rightsholder-maintenance-user-permissions-profile-wrapper" },
            react_1.default.createElement("div", { className: 'global-container' },
                react_1.default.createElement(PermissionHeadMenu_1.default, { onOpenConfirmPopup: onOpenConfirmPopup }),
                react_1.default.createElement("div", { className: 'head-title' },
                    react_1.default.createElement("h2", null, "Profile"),
                    react_1.default.createElement(UserInfoAvatar_1.UserInfoAvatar, { userInfo: rightsholderUser })),
                loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(AssignedPermissionGroups_1.default, { setEditActionsGroups: setEditActionsGroups, editIsDisabled: editIsDisabled, setMyUserGroups: setMyUserGroups, myUserGroups: myUserGroups, rightsholderUser: rightsholderUser, editActionsGroups: editActionsGroups, onOpenConfirmPopup: onOpenConfirmPopup, onCancelEdit: onCancelEdit, setEditIsDisabled: setEditIsDisabled }))),
            react_1.default.createElement(ModalPortal_1.default, { isOpen: confirmPopupIsOpen, onClose: () => setConfirmPopupIsOpen(false) },
                react_1.default.createElement(Popup_1.default, { onClose: () => setConfirmPopupIsOpen(false) },
                    react_1.default.createElement(UserPermissionsModal_1.default, { myUserGroups: myUserGroups, setUsersGroup: setUsersGroup, getUsersForUser: getUsersForUser, rightsholderUser: rightsholderUser, setRightsholderUser: setRightsholderUser, onCloseConfirmPopup: onCloseConfirmPopup, onCancelEdit: onCancelEdit, editActionsGroups: editActionsGroups, actionType: actionType }))))));
};
exports.default = (0, mobx_react_1.observer)(RightsholderMaintenanceUserPermissionsProfile);
